export function initLoadMoreRelated() {
  (function ($) {
    const $relatedGrid = $("#related-articles-grid");
    const $loadMoreBtn = $("#load-more-related");
    const $relatedWrapper = $("#related-wrapper");

    let currentPage = 1;
    const categoryId = parseInt($relatedGrid.data("category-id")); // Get from HTML data attribute

    $loadMoreBtn.on("click", function () {
      currentPage++;

      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "load_more_related_articles",
          page: currentPage,
          category_id: categoryId,
          current_post: $("#related-articles-grid").data("post-id"),
        },
        beforeSend: function () {
          $loadMoreBtn.prop("disabled", true).text("Loading...");
        },
        success: function (response) {
          if (response.success && response.data.content.trim() !== "") {
            $relatedGrid.append(response.data.content);
            $loadMoreBtn.prop("disabled", false).text("Load More Related");

            if (currentPage >= response.data.max) {
              $relatedWrapper.html(
                '<p class="text-gray-600 text-lg font-medium mt-6">🎉 No more related blogs.</p>'
              );
            }
          } else {
            $relatedWrapper.html(
              '<p class="text-gray-600 text-lg font-medium mt-6">🎉 No more related blogs.</p>'
            );
          }
        },
        error: function () {
          $relatedWrapper.html(
            '<p class="text-red-500 text-lg font-medium mt-6">⚠ Error loading related posts.</p>'
          );
        },
      });
    });
  })(jQuery);
}
